__turbopack_context__.v({
  "button": "FileUpload-module__hrfdja__button",
  "deleteButton": "FileUpload-module__hrfdja__deleteButton",
  "error": "FileUpload-module__hrfdja__error",
  "fileList": "FileUpload-module__hrfdja__fileList",
});
